module.exports = __webpack_public_path__ + "static/gt-bc5b62b6825c78f6a907cb2d6e3ace1a.svg";